export default {"src":"/_next/static/media/login-icon.95647332.svg","height":10,"width":9};